<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div class="wy-filter-item-date" v-if="filter">
    <el-dropdown-item>
      <span class="filter-title">{{filter.label}}:</span>
      <el-date-picker
        :appendToBody="false"
        v-model="filter.value"
        type="daterange"
        size="mini"
        class="date-filter-picker"
        value-format="yyyy-MM-dd"
        range-separator="To"
        start-placeholder="Start date"
        end-placeholder="End date"
        popper-class="date-filter-picker-panel">
      </el-date-picker>
    </el-dropdown-item>
    <span class="filter-title-clear" @click="clearMe(filter)">Clear</span>
  </div>
</template>

<script>
export default {
  name: 'wy-filter-item-date',
  props: ["filter"],

  methods: {
    handleChange(filter, item) {
      if(filter.isRequire) {
        if(filter.value.length == 0) {
          filter.value.push(item.key)
        }
      }
    },
  }
}
</script>

